import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_9ba39nqpzf: FaireCollectionEntity = {
  token: "pbc_9ba39nqpzf",
  type: "collection",
  name: "sticker sheets",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d5b0cc416301ac7e2ff28d85ffb477e3828cd3d7e6314e0b185293534bca3b5.jpeg",
  itemCount: 22,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.514Z",
    importedBy: "entity-db-import-collections",
  },
};
